module.exports = __webpack_public_path__ + "d1eb6361926152ce5d18e5afb3e0f4dc.svg";